import { Injectable, Output, EventEmitter } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';
import { BehaviorSubject, Observable, Subject } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  count = 0;
  currentMessage = new BehaviorSubject(null);
  // private notificationCount = new Subject<any>();
  notificationCount = new BehaviorSubject<any>(this.count);
  // shareNotifyCount = this.notificationCount.asObservable()

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    public http: HttpClient,
    private toastr: ToastrService

  ) {
    this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        console.log("what is in this firs api");

        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    )
  }


  // newCountObservable(): Observable<any> {
  //   return this.notificationCount.asObservable();
  // }

  requestPermission(data) {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        console.log("this is the token by fire base system", token);
        data['token'] = token
        this.addEntry(data);
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload: any) => {
        // this.notificationCount.emit({ count: true })
        if (payload) {
          console.log("PAYLOAD IS RECEVIED", payload)
          // this.totalCounts()
          this.http.get(config.baseApiUrl + "notification/total-count").subscribe((res: any) => {
            console.log("Get clients : ", res);
            // observer.next(res.data);
            // this.count = res.data
            this.notificationCount.next({ count: res.data })
          }, err => {
            // observer.error(err)
          }, () => {
            // observer.complete();
          })
          // });

          // this.notificationCount.next({ count: true })
          console.log("This is more important notification", payload.data.gcm);
          setTimeout(() => {
            this.toastr.success(payload.notification.title, payload.notification.body, {
              disableTimeOut: true,
              closeButton: true,
              enableHtml: true
            });
          }, 500)
        } else {
          // this.notificationCount.next({ count: false })
        }
      })
  }


  getNotificationCount(): Observable<any> {
    return this.notificationCount.asObservable();
    // return this.notificationCount.next(this.count)
  }


  /**
   * @param udata
   * Add token for login user 
   */
  addEntry(udata) {
    console.log("notification data", udata);
    this.http.post(config.baseApiUrl + "notification/token", udata).subscribe((success) => {
      console.log("notification data", success)
    });
  }


  /**
   * Get All Notification for login user
   */
  getNotifications(data): Observable<any> {


    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "notification?flag=" + data).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data);
        this.notificationCount.next({ count: res.data && res.data.count ? res.data.count : 0 })
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }


  // getReadNotifications(): Observable<any> {


  //   var that = this;
  //   return new Observable<any>((observer) => {
  //     console.log("Observable");
  //     this.http.get(config.baseApiUrl + "notification/read").subscribe((res: any) => {
  //       console.log("Get clients : ", res);
  //       observer.next(res.data);
  //       this.notificationCount.next({ count: res.data && res.data.count ? res.data.count : 0 })
  //     }, err => {
  //       observer.error(err)
  //     }, () => {
  //       observer.complete();
  //     })
  //   });

  // }

  markRead(data): Observable<any> {
    console.log("function call mark as read", data)

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "notification/mark-read?id=" + data).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data);

      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  // console.log("id use for mark as read",data)

  allRead(data): Observable<any> {
    console.log("function call mark as read", data)

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "notification/all-mark-read", data).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data);
        this.notificationCount.next({ count: res.data && res.data.count ? res.data.count : 0 })
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }





  totalCounts(): Observable<any> {
    console.log("call this function or not");

    var that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "notification/total-count").subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data);
        this.count = res.data
        this.notificationCount.next({ count: res.data })
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }


  sendPushNotificationToStaff(id): Observable<any> {
    console.log("Editing Time", id);
    let data = {
      allotmentId: id
    }
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "notification/submission-notification", data).subscribe((res: any) => {
        observer.next(res.msg);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

}
